import { OrganizationOverviewGroupProps } from "/Models/Generated/OrganizationOverviewGroupProps";
import "./OrganizationOverviewGroup.scss";
import cn from "classnames";
import OrganizationOverviewItem from "../OrganizationOverviewItem/OrganizationOverviewItem";
import { OptimizelyEditProperty } from "/App.Components";

interface Props extends OrganizationOverviewGroupProps {
  isFirst?: boolean;
  isLast?: boolean;
  id: string;
}

const OrganizationOverviewGroup = ({
  heading,
  headingPropertyName,
  items,
  itemsPropertyName,
  isFirst,
  isLast,
  id,
}: Props) =>
  heading || headingPropertyName || items || itemsPropertyName ? (
    <div className="organization-overview-group">
      <div className="organization-overview-group__left">
        <div
          className={cn("organization-overview-group__left-top", {
            "organization-overview-group__left-top--with-line": !isFirst,
          })}
        ></div>
        <div
          className={cn("organization-overview-group__left-bottom", {
            "organization-overview-group__left-bottom--with-line": !isLast,
          })}
        ></div>
      </div>
      <div className="organization-overview-group__right">
        <OptimizelyEditProperty propertyName={headingPropertyName}>
          {heading && (
            <h2 className="organization-overview-group__heading">{heading}</h2>
          )}
        </OptimizelyEditProperty>
        {(items || itemsPropertyName) && (
          <OptimizelyEditProperty propertyName={itemsPropertyName} clientRender>
            <div
              className={cn("organization-overview-group__item-container", {
                "organization-overview-group__item-container--with-spacing":
                  !isLast,
              })}
            >
              {items?.map((item, idx) => (
                <OrganizationOverviewItem
                  id={id + "-" + idx}
                  key={idx}
                  {...item}
                />
              ))}
            </div>
          </OptimizelyEditProperty>
        )}
      </div>
    </div>
  ) : null;

export default OrganizationOverviewGroup;
